import dynamic from "next/dynamic";
const Campaign = dynamic(() => import("@/components/campaign/Campaign"));
const PageHead = dynamic(() => import("@/components/PageHead"));
import { useI18n } from "@/i18n/I18nProvider";

export default function NewsletterPage() {
   const { t } = useI18n();
  
   return <>
      <PageHead />
      <Campaign type="newsletter" title={t.Campaign.Title1} subTitle={t.Campaign.Title2} source={23} />
   </>
}
